import { hexToChannels } from './darkPalette';

const HEX = /^#(?:[0-9a-f]{3}|[0-9a-f]{6})$/i;

// Below this spread between channels a light fill reads as near-white grey,
// not as a hue (#F4F4FB → 7).
const NEUTRAL_CHROMA = 16;

const chroma = (hex: string) => {
  const channels = hexToChannels(hex).split(' ').map(Number);
  return Math.max(...channels) - Math.min(...channels);
};

/**
 * A light pastel fill (icon circles on the dashboard, reports, notifications
 * and activity feeds) for dark mode, where at full strength it glares on the
 * dark page.
 *
 * - A pastel hue keeps its colour at reduced opacity:
 *   `rgb(<channels> / var(--kula-dark-pastel-alpha, 1))`. The alpha variable
 *   is declared only in dark mode, so light mode renders the exact colour.
 * - A near-white neutral (no hue to keep) becomes the dark primary tint, the
 *   way the theme's own `primary-25`/`primary-50` circles do.
 * - Values that already go through a theme variable or token are returned
 *   as is.
 */
export const pastelBg = (color: string): string => {
  if (!HEX.test(color)) return color;
  return chroma(color) < NEUTRAL_CHROMA
    ? `var(--kula-dark-primary-50, ${color})`
    : `rgb(${hexToChannels(color)} / var(--kula-dark-pastel-alpha, 1))`;
};
